import { useCallback, useState } from "react";
import { fetchGemsPriceUsd } from "./fetchGemsPrice";

/** GEMS/USD state + manual refetch (polling lives in Banner). */
export default function useGemsPrice() {
  const [gemsPriceUsd, setGemsPriceUsd] = useState(0);

  const refetchGemsPrice = useCallback(async () => {
    try {
      const px = await fetchGemsPriceUsd();
      if (px > 0) setGemsPriceUsd(px);
      return px;
    } catch (err) {
      console.warn("refetchGemsPrice:", err?.message || err);
      return 0;
    }
  }, []);

  return { gemsPriceUsd, refetchGemsPrice };
}
